import { __rest } from "tslib";
import React, { forwardRef } from 'react';
import Link from "../../../helpers/Link";
import CTA from '../CTA';
const CTALink = forwardRef((_a, ref) => {
    var { Tag = Link, reset = true } = _a, props = __rest(_a, ["Tag", "reset"]);
    return (React.createElement(CTA, Object.assign({ Tag: Tag, reset: reset }, props, { ref: ref })));
});
export default CTALink;
//# sourceMappingURL=CTALink.js.map